(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicalPieceSearch', MusicalPieceSearch);

    MusicalPieceSearch.$inject = ['$resource'];

    function MusicalPieceSearch($resource) {
        var resourceUrl =  'api/_search/musical-pieces/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
